import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  user_role_id :number;
  isAdmin :boolean=false;

  first_name :string="";
  last_name :string="";
  mobile :string="";
  showroom_name :string="";
  region_name :string="";
  profile_picture:string="";
  role_name:string="";
  email:string="";
  isView:boolean=false;

  constructor() { }

  ngOnInit(): void {

    var userdata = localStorage.getItem('userInformation');
    var _data = JSON.parse(userdata);
    if(_data) {
      this.user_role_id = _data.role_id;
      this.first_name = _data.first_name;
      this.last_name = _data.last_name;
      this.mobile = _data.mobile;
      this.profile_picture = _data.profile_picture;
      this.email = _data.email;
      this.role_name = _data.role_name;
      if(_data.region_id ==0 && _data.showroom_id == 0){
        this.showroom_name = "All Showroom";
        this.region_name = "All Region";
        return
      }
      this.showroom_name = _data.showroom_name;
      this.region_name = _data.region_name;
 


    }
  }

}
